import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetails from './pages/ProductDetails';
import Varieties from './pages/Varieties';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import './styles/global.css';

// Updates <title> on every page for SEO
function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const titles = {
      '/':          'R&R Food Products | Riya & Rakshya — Nepal\'s No.1 Snacks',
      '/products':  'All Products | RNR Food Products Nepal',
      '/varieties': 'Snack Varieties | R&R Food Products',
      '/about':     'About Us | Riya & Rakshya Food Products Nepal',
      '/contact':   'Contact | RNR Food Products Bhairahwa Nepal',
      '/cart':      'Your Cart | R&R Food Products',
      '/wishlist':  'Wishlist | R&R Food Products',
    };
    document.title = titles[pathname] || 'R&R Food Products | Riya & Rakshya Nepal';
  }, [pathname]);
  return null;
}

// Scroll to top on route change
function ScrollToTop() {
  const { pathname, search, hash, key } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search, hash, key]);

  return null;
}

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetails />} />
            <Route path="/varieties" element={<Varieties />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="*" element={
              <div style={{ textAlign: 'center', padding: '80px 24px' }}>
                <h1 style={{ fontSize: 60, fontWeight: 900, color: '#C8102E' }}>404</h1>
                <h2>Page Not Found</h2>
                <a href="/" style={{ color: '#C8102E', fontWeight: 600, display: 'block', marginTop: 20 }}>Go Home →</a>
              </div>
            } />
          </Routes>
          <PageTitle />
        </Layout>
      </Router>
    </AppProvider>
  );
}
